module.exports = {
      id: "kishoralo-usage",
      viewBox: "0 0 512 209.434",
      url: "/" + "sprite-326d1762f7ed1f924194ae9c5468ee69.svg#kishoralo",
      toString: function () {
        return this.url;
      }
    }